// extracted by css-extract-rspack-plugin
export default {"tooltipContent":"z7j6EJ"};